module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-detail/modal-history-change/modal-history-change.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-detail/modal-history-change/modal-history-change.component.sass
// module chunks = main